var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.244 9.65h-3.128V5.2c-.116-.72-.96-.524-.981 0v5.09c.021.365.392.648.676.655h3.433c.96-.145.705-1.28 0-1.309v.015zM10 16.72a6.764 6.764 0 01-6.764-6.75 6.764 6.764 0 1113.528 0A6.763 6.763 0 0110 16.72zM10 2a8 8 0 00-8 7.97 8 8 0 0016 0A8 8 0 0010 2z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default ForwardRef;